 /// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />
/// <reference path="../../../../node_modules/foundation-sites/dist/js/foundation.d.ts" />
/// <reference path="../../../../node_modules/foundation-sites/js/foundation.core.js" />


declare var irep: IREP.IREP;

namespace IREP {
    "use strict";

    export interface IStoreManagerOptions {

    }

    export class StoreManager extends Component {
        private options: IStoreManagerOptions;
        private submitButton: JQuery;
        private formValidation: JQuery;
        private usernameContainer: JQuery;
        private usernameCtrl: JQuery;
        private firstNameContainer: JQuery;
        private firstNameCtrl: JQuery;
        private lastNameContainer: JQuery;
        private lastNameCtrl: JQuery;
        private passwordCtrl: JQuery;
        private passwordContainer: JQuery;
        //private passwordField: JQuery;
        //private passwordMatchError: JQuery;
        private confirmPasswordContainer: JQuery;
        private confirmPasswordCtrl: JQuery;
        private editNameBtn: JQuery;
        private editUsernameBtn: JQuery;
        private selectCultureBtn: JQuery;
        private cultureMenu: JQuery;
        private termsAgree: JQuery;
        private emailFormatFail: JQuery;
        private emailExistsFail: JQuery;
        private itpUsernameCtrl: JQuery;
        private itpBusinessIdCtrl: JQuery;
        private itpBtn: JQuery;
        private itpFail: JQuery;

        private $loadingAnimation: JQuery;

        constructor(id: string, options: IStoreManagerOptions) {
            super(id);
            this.options = options;


            this.formValidation = this.$component.find("#formSubmit");
            this.submitButton = this.$component.find("#submit");
            this.editNameBtn = this.$component.find(".sfr-edit-name-btn");
            this.editUsernameBtn = this.$component.find(".sfr-edit-username-btn");
            this.selectCultureBtn = this.$component.find(".sfr-manager-reg-culture-select");
            this.cultureMenu = this.$component.find(".languageSelectorMenu");
            this.passwordCtrl = this.$component.find(".password input");
            this.passwordContainer = this.$component.find(".password-container");
            this.confirmPasswordContainer = this.$component.find(".confirm-password-container");
            this.confirmPasswordCtrl = this.$component.find(".confirm-password-container input");
            this.usernameContainer = this.$component.find(".username");
            this.usernameCtrl = this.$component.find(".username input");
            this.firstNameContainer = this.$component.find(".first-name");
            this.firstNameCtrl = this.$component.find(".first-name input");
            this.lastNameContainer = this.$component.find(".last-name");
            this.lastNameCtrl = this.$component.find(".last-name input");
            this.termsAgree = this.$component.find("#AgreeTerms");
            this.emailFormatFail = this.$component.find("#emailFormatFail");
            this.emailExistsFail = this.$component.find("#emailExistsFail");
            this.itpUsernameCtrl = this.$component.find("#ITPUsername");
            this.itpBusinessIdCtrl = this.$component.find("#ITPBusinessId");
            this.itpBtn = this.$component.find("#ITPSubmit");
            this.itpFail = this.$component.find("#ITPFail");

            this.submitButton.on("click", (e) => this.register(e));
            this.passwordCtrl.on("keyup", (e) => this.updateRequirements());
            this.passwordCtrl.on("change", (e) => { this.validatePasswords(); });
            this.confirmPasswordCtrl.on("change", (e) => { this.validatePasswords(); });
            this.editNameBtn.on("click", (e) => this.showEditName());
            this.editUsernameBtn.on("click", (e) => this.showEditUsername());
            this.selectCultureBtn.on("click", () => this.toggleCultureMenu());
            this.itpBtn.on("click", (e) => this.getUIDFromITP(e));

            this.$loadingAnimation = this.$component.find(".loading-container");
            
            //this.signInBtn = $(".signin-btn");
            //this.signInBtn.on("click", (e) => this.signIn(e));

            //make sure this cookie aint a thing
            this.deleteManagerCookie("manageruid");

            // sfr invite code stuff.. 
            if (this.getUrlParameter("invitecode") !== '') {
                // hide the edit name button and show the fields
                this.editNameBtn.hide();
                this.showEditName();
                // hide the email edit button
                this.editUsernameBtn.hide();
            }
            // else og, set cookie
            else {
                this.deleteManagerCookie("manageruid");
                this.setManagerCookie("manageruid", $("#SFRManager").data("uid"), 1);
            }

            if (this.firstNameCtrl.length && (this.firstNameCtrl.val().trim() === "" || this.lastNameCtrl.val().trim() === "")) {
                this.editNameBtn.hide();
                this.showEditName();
            }
        }

        // get query string params, there's a fancy new api for URLSearchParams, but might as well make a helper for max compat
        private getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };

        private setManagerCookie(cname: any, cvalue: any, exdays: any) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        private deleteManagerCookie(cname: any) {
            document.cookie = cname + "=; expires=Sun, 01 Jan 2018 00:00:00 UTC; path=/;";
        }


        private toggleCultureMenu() {
            if (this.cultureMenu.css("display") == "none") this.cultureMenu.show(); else this.cultureMenu.hide();
        }

        private showEditName() {
            $(".sfr-manager-static-name").hide();
            $(".sfr-manager-edit-name").css("display", "flex");
        }

        private showEditUsername() {
            $(".sfr-manager-static-username").hide();
            $(".sfr-manager-edit-username").css("display", "flex");
        }

        private updateRequirements() {
            this.passwordRequirements(this.passwordCtrl.val());
        }

        private validatePasswords() {
            this.passwordContainer.removeClass("has-error");
            this.confirmPasswordContainer.removeClass("has-error");
            ////this.passRules.removeClass("has-error");
            //this.passwordMatchError.addClass("hidden");
            var res = this.validatePassword(this.passwordCtrl.val(), this.confirmPasswordCtrl.val());
            if (res.success == false) {
                switch (res.message) {
                    case "PASSWORDS DONT MATCH":
                        if (this.confirmPasswordCtrl.val().length != 0) {
                            this.passwordContainer.addClass("has-error");
                            this.confirmPasswordContainer.addClass("has-error");
                            //this.passwordMatchError.removeClass("hidden");
                            return false;
                        }
                        break;
                    case "INVALID PASSWORD":
                        this.passwordContainer.addClass("has-error");
                        ////this.passRules.addClass("has-error");
                        //PasswordProcessor.requirementsReport(this.passwordCtrl.val());
                        return false;
                }
            }
            return true;
        }

        private validatePassword(password: string, confirmPassword: string) {
            let isValid = {
                success: false,
                message: "INVALID PASSWORD"
            };

            //Logic to test that at least three of these four need to be true
            if (this.checkPasswordRequirements(password)) {
                if (!this.checkPasswordAndConfirmMatch(password, confirmPassword)) {
                    isValid.success = false;
                    isValid.message = "PASSWORDS DONT MATCH";
                } else {
                    isValid.success = true;
                    isValid.message = "SUCCESS"
                }
            }

            return isValid;
        }

        private checkPasswordAndConfirmMatch(password: string, confirmPassword: string): boolean {
            return (password.trim() === confirmPassword.trim());
        }

        private passwordRequirements(password: string) {
            let upper = new RegExp("[A-Z]").test(password);
            let lower = new RegExp("[a-z]").test(password);
            let number = new RegExp("[0-9]").test(password);
            let special = new RegExp("[^A-Za-z0-9]").test(password);

            if (password.length >= 6) $(".reqLength").removeClass("unchecked"); else $(".reqLength").addClass("unchecked");
            if (upper) $(".reqCapital").removeClass("unchecked"); else $(".reqCapital").addClass("unchecked");
            if (lower) $(".reqLower").removeClass("unchecked"); else $(".reqLower").addClass("unchecked");
            if (number) $(".reqNumber").removeClass("unchecked"); else $(".reqNumber").addClass("unchecked");
            if (special) $(".reqSpecial").removeClass("unchecked"); else $(".reqSpecial").addClass("unchecked");
        }

        private checkPasswordRequirements(password: string): boolean {
            //Must be at least 6 characters long and match 3 of 4 categories: Capital Letter, lowercase letter, number, and special character 
            let upper = new RegExp("[A-Z]").test(password);
            let lower = new RegExp("[a-z]").test(password);
            let number = new RegExp("[0-9]").test(password);
            let special = new RegExp("[^A-Za-z0-9]").test(password);

            //Logic to test that at least three of these four need to be true
            return ([upper, lower, number, special].filter(function (e) { return e == true }).length >= 3 && password.length >= 6);
        }

        private validate() {
            //this.bindValidation(this.formValidation, false);
            this.usernameContainer.removeClass('has-error');
            this.firstNameContainer.removeClass('has-error');
            this.lastNameContainer.removeClass('has-error');
            this.hideEmailUniqueError();

            //validate all the form components. 
            var res = true;
            if (this.usernameCtrl.val().trim() == "" || !this.validEmail(this.usernameCtrl.val().trim())) {
                this.usernameContainer.addClass('has-error');
                res = false;
            }
            if (this.firstNameCtrl.val().trim() == "") {
                this.firstNameContainer.addClass('has-error');
                res = false;
            }
            if (this.lastNameCtrl.val().trim() == "") {
                this.lastNameContainer.addClass('has-error');
                res = false;
            }
            if (!this.formValidation.valid() || !this.validatePasswords() || !this.validateEmailFormat()) {
                //this.verificationWarning.removeClass("hidden");
                //$(window).scrollTop(0);
                res = false;
            }
            if (this.toggleCheck() == false) {
                //this.verificationWarning.removeClass("hidden");
                res = false;
            }

            return res;
        }

        private toggleCheck() {
            //this.ageCheck.parents('.control-row').removeClass('has-error');
            this.termsAgree.parents('.sfr-check-container').removeClass('has-error');
            //this.ageFail.addClass('hidden');
            //this.termsFail.addClass('hidden');

            var res = true;
            //if (!this.ageCheck.is(":checked")) {
            //    this.ageCheck.parents('.control-row').addClass('has-error');
            //    this.ageFail.removeClass('hidden');
            //    res = false;
            //}
            if (!this.termsAgree.is(":checked")) {
                this.termsAgree.parents('.sfr-check-container').addClass('has-error');
                //this.termsFail.removeClass('hidden');
                res = false;
            }

            return res;
        }

        private validateEmailFormat() {
            //this.emailExistsFail.addClass("hidden");
            //this.emailFormatFail.addClass("hidden");
            this.usernameContainer.removeClass('has-error');
            this.hideEmailFormatError();

            //Test e-mail address format. 
            if (!this.validEmail(this.usernameCtrl.val().trim())) {
                this.usernameContainer.addClass('has-error');
                this.showEmailFormatError();
                //this.emailFormatFail.removeClass("hidden");
                return false;
            }
            return true;
        }

        private validEmail(email: string) {
            // updating the regex below because this doesnt apply to new TLDs
            let emailRegex = /.@./;
            return emailRegex.test(email);
        }

        private validateEmailUnique() {
            this.usernameContainer.removeClass('has-error');

            //Check if email exists
            var qq = this;
            this.emailUnique().done(function (data) {
                if (data.Exists) {
                    qq.usernameContainer.addClass('has-error');
                }
            });
        }

        private emailUnique() {
            return $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + "UsernameExists",
                data: { checkName: this.usernameCtrl.val() }
            })
        }

        private hideEmailUniqueError() {
            this.usernameContainer.removeClass('has-error');
            this.emailExistsFail.addClass("hidden");
        }

        private showEmailUniqueError() {
            this.usernameContainer.addClass('has-error');
            this.emailExistsFail.removeClass("hidden");
        }

        private hideEmailFormatError() {
            this.usernameContainer.removeClass('has-error');
            this.emailFormatFail.addClass("hidden");
        }

        private showEmailFormatError() {
            this.usernameContainer.addClass('has-error');
            this.emailFormatFail.removeClass("hidden");
        }

        private getUIDFromITP(e: JQueryEventObject) {
            var qq = this;

            qq.itpFail.addClass("hide");
            qq.$loadingAnimation.show();

            e.preventDefault();

            if (qq.itpUsernameCtrl.val().trim() != "" && qq.itpBusinessIdCtrl.val().trim() != "") {
                irep.callApi({
                    url: "storemanager/uidfromitp",
                    type: "GET",
                    data: {
                        username: qq.itpUsernameCtrl.val(), iTPBusinessId: qq.itpBusinessIdCtrl.val()
                    }
                }).done(function (data) {
                    qq.$loadingAnimation.hide();

                    if (data.uid != undefined && data.uid != null && data.uid != "" && data.uid != "00000000000000000000000000000000") {
                        window.location.assign(irep.options.appUrl + "/storeregister?manageruid=" + data.uid);
                    }
                    else {
                        qq.itpFail.removeClass("hide");
                        qq.$loadingAnimation.hide();
                    }
                });
            }
            else {
                qq.itpFail.removeClass("hide");
                qq.$loadingAnimation.hide();
            }
        }

        private register(e: JQueryEventObject) {
            this.$loadingAnimation.show();
            var qq = this;
            //We submit the form via AJAX so we can process the next page directly. We don't do a full post-back here, because this control is independent of the URL.
            e.preventDefault();
            //Because we are submitting the form via AJAX, we need to run validation manually. If validation fails, stop execution. 
            if (!this.validate()) {
                this.$loadingAnimation.hide();
                return;
            }


            this.hideEmailUniqueError();
            var that = this; // rescope this
            this.emailUnique().done(function (data) {
                if (data.Exists) {
                    qq.showEmailUniqueError();
                    qq.$loadingAnimation.hide();
                } else {
                    $.ajax({
                        type: "post",
                        dataType: "html",
                        url: irep.options.appUrl + "SubmitNewStoreManagerMember",
                        //Serializes all parts of the form including the anti-forgery token. 
                        //Concatenate the sub-form. Kinda hack-ish. But it works. 
                        data: qq.formValidation.serialize() //+ "&" + qq.storePosition.getResults()
                    }).done(function (data) {
                        //Move on to the next step. 
                        //qq.registrationContainer.html(data);
                        //qq.configurePage();

                        // switch for manager or member
                        // if we have an invite code then this is a member signup so send them to the landing page
                        if (that.getUrlParameter("invitecode")) {
                            window.location.assign(irep.options.appUrl + irep.options.user.site + "/landing"); // can i just send to appUrl? should have usercontext at that point
                        }
                        else {
                            // else it's the OG functionality of signing up the manager
                            window.location.assign(irep.options.appUrl + irep.options.user.site + "/storemanagerdashboard?manageruid=" + $("#SFRManager").data("uid"));
                        }
                    }).fail(function (data, e) {
                        that.$loadingAnimation.hide();
                        
                        //Server side validation error occurred -- Show the error. 
                        //qq.verificationWarning.removeClass("hidden");
                        //var errorField = $("#" + Object.keys($.parseJSON(data.statusText))[0]);
                        //if (errorField !== undefined && errorField !== null) {
                        //    errorField.parent(".control-row").addClass('has-error');
                        //}
                        //qq.validationSummary.html((<any>Object).values($.parseJSON(data.statusText))[0]);
                        //qq.validationSummary.removeClass('hidden');
                        //$(window).scrollTop(0);
                    });
                }
            });

        }

        //function getEMEACookie(cname) {
        //    var name = cname + "=";
        //    var decodedCookie = decodeURIComponent(document.cookie);
        //    var ca = decodedCookie.split(';');
        //    for (var i = 0; i < ca.length; i++) {
        //        var c = ca[i];
        //        while (c.charAt(0) == ' ') {
        //            c = c.substring(1);
        //        }
        //        if (c.indexOf(name) == 0) {
        //            return c.substring(name.length, c.length);
        //        }
        //    }
        //    return "";
        //}

        //function checkEMEACookie() {
        //    var c = getEMEACookie("emeaCookie");
        //    if (c == "false") {
        //        $("#CookieDesc").show().animate({ bottom: 0 }, 500);
        //        setEMEACookie("emeaCookie", "false", 365);
        //    } else if (c == "true") {
        //        //console.log(c);
        //        $("#CloseCookieWarning").hide();
        //    } else {
        //        $("#CookieDesc").show().animate({ bottom: 0 }, 500);
        //        setEMEACookie("emeaCookie", "false", 365);
        //    }
        //}


    }
}

